import axios from 'axios';
import types from './categoryTypes';

import _ from 'lodash';
import { toastr } from "react-redux-toastr";

import { BASE_API, USER_TOKEN } from '../../../../config/consts';
import { initializeForm, reset } from "../../../../helpers/redux";
import { errors2String } from '../../../../helpers/utils';

const URL = `${BASE_API}/categories/`;

/**
 * Função que serve para trazer todos os paises cadastradas sem paginação
 * @returns {Object} Evento com a Promise da requisição. o redux-promise irá
 * tratar de resolver a Promise antes de atualizar o reducer
 */
export const getListAll = () => {
    return (dispatch) => {
        axios.get(`${URL}?limit=999999`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(localStorage.getItem(USER_TOKEN)).token}`
            }
        }).then((response) => {
            dispatch({
                type: types.CATEGORY_FETCHED,
                payload: response
            });
        }).catch((err) => {
            try {
                const errors = errors2String(err.response.data.content.errors);
                dispatch({ type: 'ERROR_CATEGORY_FECHED'});
                toastr.error('Erro!', errors);
            } catch (error) {
                dispatch({ type: 'ERROR_CATEGORY_FECHED'});
                toastr.error('Erro!', 'Erro no servidor, favor verificar a politica de CORS');
                console.log(err);
            }
        });
    }
}
/**
 * Função que serve para trazer todos os paises cadastradas
 * @returns {Object} Evento com a Promise da requisição. o redux-promise irá
 * tratar de resolver a Promise antes de atualizar o reducer
 */
export const getList = () => {
    return (dispatch) => {
        axios.get(URL, {
            headers: {
                Authorization: `Bearer ${JSON.parse(localStorage.getItem(USER_TOKEN)).token}`
            }
        }).then((response) => {
            dispatch({
                type: types.CATEGORY_FETCHED,
                payload: response
            });
        }).catch((err) => {
            try {
                const errors = errors2String(err.response.data.content.errors);
                dispatch({ type: 'ERROR_CATEGORY_FECHED'});
                toastr.error('Erro!', errors);
            } catch (error) {
                dispatch({ type: 'ERROR_CATEGORY_FECHED'});
                toastr.error('Erro!', 'Erro no servidor, favor verificar a politica de CORS');
                console.log(err);
            }
        });
    }
}

export const getListFiltered = (user_id, filters) => {
    return (dispatch) => {
        const filtersFields = _.isNull(filters) ? '' : '&'+filters ;
        axios.get(`${URL}?owner=${user_id}${filtersFields}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(localStorage.getItem(USER_TOKEN)).token}`
            }
        }).then((response) => {
            dispatch({
                type: types.CATEGORY_FETCHED,
                payload: response
            });
        }).catch((err) => {
            try {
                const errors = errors2String(err.response.data.content.errors);
                dispatch({ type: 'ERROR_CATEGORY_FECHED'});
                toastr.error('Erro!', errors);
            } catch (error) {
                dispatch({ type: 'ERROR_CATEGORY_FECHED'});
                toastr.error('Erro!', 'Erro no servidor, favor verificar a politica de CORS');
                console.log(err);
            }
        });
    }
}

/**
 * Função que serve para trazer os paises cadastradas de forma paginada
 * @returns {Object} Evento com a Promise da requisição. o redux-promise irá
 * tratar de resolver a Promise antes de atualizar o reducer
 */
export const getPage = (page) => {
    return (dispatch) => {
        axios.get(`${URL}?page=${page}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(localStorage.getItem(USER_TOKEN)).token}`
            }
        }).then((response) => {
            dispatch({
                type: types.CATEGORY_FETCHED,
                payload: response
            });
        }).catch((err) => {
            try {
                const errors = errors2String(err.response.data.content.errors);
                dispatch({ type: 'ERROR_CATEGORY_FECHED'});
                toastr.error('Erro!', errors);
            } catch (error) {
                dispatch({ type: 'ERROR_CATEGORY_FECHED'});
                toastr.error('Erro!', 'Erro no servidor, favor verificar a politica de CORS');
                console.log(err);
            }
        });
    }
}

/**
 * Função que trás os detalhes de um servidor
 * @param {Number} id
 * @returns {Object} Evento com a Promise da requisição. o redux-promise irá
 * tratar de resolver a Promise antes de atualizar o reducer
 */
export const getDetail = (id) => {
    return (dispatch) => {
        axios.get(`${URL}${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(localStorage.getItem(USER_TOKEN)).token}`
            }
        }).then((response) => {
            const formValues = {
                ...response.data.content,
            }
            dispatch([
                {
                    type: types.CATEGORY_DETAIL_FETCHED,
                    payload: response
                },
                reset('categoryForm'),
                initializeForm('categoryForm', formValues)
            ]);
        }).catch((err) => {
            try {
                const errors = errors2String(err.response.data.content.errors);
                dispatch({ type: 'ERROR_CATEGORY_DETAIL_FETCHED'});
                toastr.error('Erro!', errors);
            } catch (error) {
                dispatch({ type: 'ERROR_CATEGORY_DETAIL_FETCHED'});
                toastr.error('Erro!', 'Erro no servidor, favor verificar a politica de CORS');
                console.log(err);
            }
        });
    };
};

/**
 * 
 * @param {Object} values Informações sobre um determinado servidor
 * que está vindo do reducer
 * @returns {Array} Vários eventos sendo que:
 * Elemento 0 - Dados do servidor para atualizar o servidor
 * Elemento 1 - Reseta os campos do formulário para evitar que venham preenchidos
 * Elemento 2 - Inicialização do form do redux-form com os dados do servidor
 */
export const setDetail = (values) => {
    return (dispatch) => {
        const formValues = {
            ...values,
        }
        dispatch([
            {
                type: types.CATEGORY_DETAIL_FETCHED,
                payload: {
                    data: {
                        content: values
                    }
                }
            },
            reset('categoryForm'),
            initializeForm('categoryForm', formValues)
        ]);
    };
};

export const create = (values, router, user_id=null) => {
    return dispatch => {
        axios.post(`${URL}`, values, {
            headers: {
                Authorization: `Bearer ${JSON.parse(localStorage.getItem(USER_TOKEN)).token}`
            }
        })
        .then(response => {
            toastr.success("Sucesso", "Operação realizada com sucesso.");
            if(user_id) {
                dispatch([reset(), getListFiltered(user_id)]);
            } else {
                dispatch([reset(), getList()]);
            }

            if (!_.isUndefined(router)) {
                router.push("/admin/paises");
            }
        })
        .catch(err => {
            try {
                const errors = errors2String(err.response.data.content.errors);
                dispatch({ type: 'ERROR_CATEGORY_CREATE'});
                toastr.error('Erro!', errors);
            } catch (error) {
                dispatch({ type: 'ERROR_CATEGORY_CREATE'});
                toastr.error('Erro!', 'Não foi possível cadastrar uma categoria, tente novamente');
                console.log(err);
            }
        });
    }
};

export const update = (values, router) => {
    return dispatch => {
        axios.put(`${URL}${values._id}`, values, {
            headers: {
                Authorization: `Bearer ${JSON.parse(localStorage.getItem(USER_TOKEN)).token}`
            }
        })
        .then(response => {
            toastr.success("Sucesso", "Operação realizada com sucesso.");
            dispatch([reset(), getList()]);

            if (!_.isUndefined(router)) {
                router.push("/admin/paises");
            }
        })
        .catch(err => {
            try {
                const errors = errors2String(err.response.data.content.errors);
                dispatch({ type: 'ERROR_CATEGORY_UPDATE'});
                toastr.error('Erro!', errors);
            } catch (error) {
                dispatch({ type: 'ERROR_CATEGORY_UPDATE'});
                toastr.error('Erro!', 'Não foi possível atualizar uma categoria, tente novamente');
                console.log(err);
            }
        });
    }
};

export const remove = (values, router, user_id) => {
    return dispatch => {
        axios.delete(`${URL}${values._id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(localStorage.getItem(USER_TOKEN)).token}`
            }
        })
        .then(response => {
            toastr.success("Sucesso", "Operação realizada com sucesso.");
            if(user_id) {
                dispatch([getListFiltered(user_id)]);
            } else {
                dispatch([getList()]);
            }

            if (!_.isUndefined(router)) {
                router.push("/admin/paises");
            }
        })
        .catch(err => {
            try {
                const errors = errors2String(err.response.data.content.errors);
                dispatch({ type: 'ERROR_CATEGORY_DELETE'});
                toastr.error('Erro!', errors);
            } catch (error) {
                dispatch({ type: 'ERROR_CATEGORY_DELETE'});
                toastr.error('Erro!', 'Não foi possível excluir uma categoria, tente novamente');
                console.log(err);
            }
        });
    }
};